import { createStore, applyMiddleware } from 'redux';
import profitAndLossReducer from '../reducers/profitAndLossReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(profitAndLossReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
